module.exports = __webpack_public_path__ + "img/Footer.ae11b1db.jpg";